import React from 'react'
import ServiceLayout from 'components/ServiceLayout'

const BLOCKS = [
  {
    title: 'Sites Institucionais',
    desc: 'Sites responsivos que apresentam sua marca com clareza e credibilidade.',
    items: [
      'Design responsivo e institucional',
      'Landing pages de alta conversão',
      'Otimização SEO on-page',
      'Integração com ferramentas de marketing',
    ],
  },
  {
    title: 'E-commerce',
    desc: 'Lojas virtuais pensadas para guiar o cliente até a compra.',
    items: [
      'E-commerces completos',
      'Experiência de navegação segura e intuitiva',
      'Otimização de checkout',
      'Integração com meios de pagamento',
    ],
  },
  {
    title: 'Integrações & CRM',
    desc: 'Tecnologia que conecta marketing, vendas e dados.',
    items: [
      'Integração com CRM',
      'Automação de fluxos e nutrição',
      'Integração de formulários e leads',
      'Dashboards e relatórios de dados',
    ],
  },
]

const STEPS = [
  { title: 'Descoberta', desc: 'Entendemos o objetivo do site e a jornada ideal do usuário.' },
  { title: 'Arquitetura', desc: 'Estruturamos páginas, fluxos e integrações necessárias.' },
  { title: 'Desenvolvimento', desc: 'Construímos com foco em performance, SEO e conversão.' },
  { title: 'Evolução', desc: 'Acompanhamos métricas e evoluímos o site continuamente.' },
]

function ServiceTech() {
  return (
    <ServiceLayout
      pageTitle='Agência Dorac - Tecnologia & Sites'
      eyebrow='Tecnologia'
      title='Tecnologia que converte'
      subtitle='Criamos websites responsivos e e-commerces otimizados, com experiência de navegação segura e foco em conversão.'
      intro='Um site bonito que não converte é só um cartão de visitas caro. Por isso desenvolvemos cada projeto pensando na jornada real do seu cliente: da primeira impressão até o clique que gera resultado, com velocidade, SEO e integrações que fazem o negócio rodar.'
      blocks={BLOCKS}
      steps={STEPS}
      ctaText='Quero um site que converte'
    />
  )
}

export default ServiceTech
